import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import EntryView from '@/views/EntryView.vue'
import QrSessionView from '@/views/QrSessionView.vue'
import PayReturnView from '@/views/PayReturnView.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', component: EntryView },
  { path: '/qr/:posMachineCode', component: QrSessionView },
  {
    path: '/qr/:posMachineCode/pay/confirm',
    component: PayReturnView,
    props: { mode: 'confirm' },
  },
  {
    path: '/qr/:posMachineCode/pay/cancel',
    component: PayReturnView,
    props: { mode: 'cancel' },
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
